<div class="featured-product">
    <div class="featured-product__header">
        {{ config.header | translate }}
    </div>

    <div class="featured-product__content">
        <div class="featured-product__description">
            <div class="featured-product__description__left">
                <div class="featured-product__description__name"
                     [innerHTML]="config.name | translate | safeHtml"
                ></div>
                <ng-container *ngTemplateOutlet="ctaButton"></ng-container>
            </div>
            <div class="featured-product__description__image">
                <img [src]="config.imageSrc" alt="">
            </div>

            <div *ngIf="config.discount"
                 class="featured-product__discount">
                <div class="featured-product__discount__discount bold">
                    {{ 'FEATURED_PRODUCTS.DISCOUNT.DISCOUNT' | translate }} {{ config.discount.percent }}%
                </div>
                <div class="featured-product__discount__code">
                    <span>{{ 'FEATURED_PRODUCTS.DISCOUNT.CODE' | translate }}</span>
                    <span class="bold">
          {{ config.discount.code }}
        </span>
                </div>
            </div>
        </div>

        <div class="featured-product__features">
            <div *ngFor="let feature of config.features"
                 class="featured-product__feature">
                <img src="./assets/images/icons/check-outlined.svg" alt="">
                <span class="featured-product__feature__text"
                      [innerHTML]="feature | translate | safeHtml"
                ></span>
            </div>
        </div>

        <div class="featured-product__cta">
            <ng-container *ngTemplateOutlet="ctaButton"></ng-container>
        </div>
    </div>


</div>

<ng-template #ctaButton>
    <a class="btn btn--secondary"
       [href]="url"
       target="_blank"
    >
        {{ 'FEATURED_PRODUCTS.GO_TO_PRODUCT' | translate }}
    </a>
</ng-template>
